import React from 'react';
import styled from 'styled-components';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Testimonials from './components/Testimonials';
import Integration from './components/Integration';
import FAQ from './components/FAQ';
import Footer from './components/Footer';

const AppContainer = styled.div`
  min-height: 100vh;
  background: linear-gradient(135deg, #0A0A0F 0%, #141923 100%);
  position: relative;
  overflow-x: hidden;
`;

const BackgroundElements = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  
  &::before {
    content: '';
    position: absolute;
    top: 20%;
    right: 10%;
    width: 300px;
    height: 300px;
    background: radial-gradient(circle, rgba(100, 150, 255, 0.1) 0%, transparent 70%);
    border-radius: 50%;
    filter: blur(40px);
  }
  
  &::after {
    content: '';
    position: absolute;
    bottom: 20%;
    left: 10%;
    width: 400px;
    height: 400px;
    background: radial-gradient(circle, rgba(100, 150, 255, 0.05) 0%, transparent 70%);
    border-radius: 50%;
    filter: blur(60px);
  }
`;

const MainContent = styled.div`
  position: relative;
  z-index: 1;
`;

function App() {
  return (
    <AppContainer>
      <BackgroundElements />
      <MainContent>
        <Header />
        <Hero />
        <Features />
        <Testimonials />
        <Integration />
        <FAQ />
        <Footer />
      </MainContent>
    </AppContainer>
  );
}

export default App; 